import { FC, ReactElement } from 'react';

import { dividerVariants } from './styles';
import { IDividerProps } from './types';

export const Divider: FC<IDividerProps> = ({ color, mode, className }): ReactElement => {
  return <hr className={dividerVariants({ color, mode, className })} />;
};
